<template>
  <div class="font">
    <div class="logo">
      <router-link to="/"
        ><div><img src="../assets/normal-logo.png" alt="logo" /></div
      ></router-link>
    </div>
    <div class="head">
        <h3>Forgot Password</h3>
        <p>Don’t worry, we got you! Let’s get you a new password. </p>
        <p class="p">Just type your email and we’ll send a mail to reset your password. </p>
    </div>
    <div class="login-hero">
      <div class="login">
        <form action="">
          <div class="errors">
            <div class="form-input">
              <img src="../assets/person.svg" />
              <input
                :class="{ error: $v.formData.email.$error }"
                type="email"
                placeholder="Email Address"
                class="input"
                @input="$v.formData.email.$touch()"
                v-model.trim="formData.email"
              />
            </div>
            <div v-if="$v.formData.email.$dirty">
              <span class="error-message" v-if="!$v.formData.email.email">
                Please enter a valid email address.
              </span>
            </div>
          </div>
          <b-button
          v-if="getStatus === 'loading'"
          loading
            class="button"
            :disabled="!formData.email || isLoading || $v.$invalid"
          >
          </b-button>
          <b-button
          v-else
            class="button"
            @click.prevent="submit"
            :disabled="!formData.email|| $v.$invalid"
          >
            <span>Submit</span>
          </b-button>
        </form>
      </div>
      <div class="footer-login">
        <p>&copy; Uptima Solutions</p>
        <p>Terms & Conditions</p>
        <p>Privacy Policy</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'Login',
  data() {
    return {
      formData: {
        email: ''
      },
      isLoading: false
    };
  },
  validations: {
    formData: {
      email: {
        required,
        email
      }
    }
  },
  computed: {
    ...mapGetters(['getStatus'])
  },
  mounted() {
    localStorage.removeItem('vuex');
    this.isLoading = false;
  },
  watch: {
    getStatus(value) {
      if (value === 'error') {
        this.isLoading = false;
        this.$buefy.toast.open({
          message: 'User not found',
          type: 'is-danger'
        });
      } else if (value === 'success') {
        this.isLoading = false;
        this.$buefy.toast.open({
          message: 'Check your email for a reset link',
          type: 'is-success'
        });
        this.formData.email = '';
      }
    }
  },
  methods: {
    ...mapActions('auth', ['forgetPassword']),
    submit() {
      this.isLoading = true;

      this.forgetPassword(this.formData);
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  padding: 45px 0 45px 100px;
}
.logo img {
  height: 50px;
}
.login-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login {
  min-width: 528px;
  background: #fcfcfc;
  box-shadow: 4px 4px 10px rgba(210, 192, 192, 0.25), -4px -4px 10px rgba(210, 192, 192, 0.25);
  padding: 50px 70px;
}
.login p {
  text-align: center;
  margin-top: 56px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #817f7f;
}
.head {
    text-align: center;
    h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 26px;
        line-height: 75px;
        letter-spacing: 2px;
        color: #5051DB;
    }
    p {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 30px;
        color: #000000;
    }
    .p {
        margin-bottom: 34px;;
    }
}
h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  text-align: center;
  margin-bottom: 46px;
}
.form-input {
  height: 45px;
  /* width: 80%; */
  background: #f6faff;
  border: 1px solid #e4e4e4;
  display: flex;
  padding: 0 18px;
  margin-bottom: 17px;
}
.error-message {
  color: red !important;
  font-size: 10px !important;
  margin: 0;
}
.errors {
  min-height: 90px;
}
input {
  border: none;
  outline: none;
}

.input {
  margin-left: 22px;
  width: 80%;
}

.input::-webkit-input-placeholder {
  color: #939393;
}
.input:focus::-webkit-input-placeholder {
  color: #5051db;
}
.check {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  margin-top: 15px;
}
.flex-check {
  display: flex;
  align-items: center;
}
.flex-check span {
  margin-left: 9px;
}
.flex-check span {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: #454141;
}
.button {
  background: #3887f6;
  border: 0.8px solid #5051db;
  width: 100%;
  padding: 15px 0;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
}
.button:hover {
  background: #5051db;
  border: 0.8px solid #5051db;
  transition: all ease-in-out 1s;
}
p {
  margin: 0;
}
.footer-login {
  margin-top: 68px;
  text-align: center;
}
.footer-login p:nth-child(1) {
  margin-bottom: 20px;
}
.footer-login p:nth-child(2) {
  margin-bottom: 8px;
}
button[disabled] {
  background: #1c17ff;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
  color: #e4e4e4;
}
button[disabled]:hover {
  background: #1c17ff;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
  color: #e4e4e4;
}
@media screen and (max-width: 768px) {
  .logo {
    padding: 50px 20px;
  }
  .login {
    min-width: 100%;
    padding: 20px;
  }
}
</style>
